import { render } from "./TwitterUploader.vue?vue&type=template&id=156bd89b&scoped=true"
import script from "./TwitterUploader.vue?vue&type=script&lang=js"
export * from "./TwitterUploader.vue?vue&type=script&lang=js"

import "./TwitterUploader.vue?vue&type=style&index=0&id=156bd89b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156bd89b"]])

export default __exports__